import React, { useEffect, useMemo, useState } from 'react';
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';

const dummy = {
  behavior_counts: {
    closed_questions: 1,
    complex_reflections: 1,
    giving_information: 2,
    mi_adherent: 2,
    mi_nonadherent: 1,
    open_questions: 3,
    simple_reflections: 1
  },
  global_scores: {
    cultivating_change_talk: 2,
    empathy: 3,
    partnership: 3,
    softening_sustain_talk: 2
  },
  justification: {
    closed_questions:
      "The salesperson asks a closed question 'Do you use an iPhone by any chance?' (00:06:07)",
    complex_reflections:
      "The salesperson offers a complex reflection when the customer mentions a problem logging in. The salesperson replied to customer about the login issue, 'No. No. I totally understand.' (00:04:49-00:04:53)",
    cultivating_change_talk:
      "The salesperson does not effectively explore the client's motivations for change, nor does the salesperson evoke much change talk. The salesperson misses opportunities to explore the client's goals or values related to yoga. They touch upon the client's interest in continuing classes, although they don't explore the reasons why the client takes classes. (00:00:37-00:00:45)",
    empathy:
      "The salesperson demonstrates some empathy by acknowledging the customer concerns and preferences, such as login issues. 'No. No. I totally understand. But, like, you can just use the app instead. Like, you can just download the MyYoga Teacher app instead.' (00:04:49-00:04:53)",
    giving_information:
      "The salesperson provides information about a 'pause feature' that is a standard option. 'Let's say you sign up, like, tomorrow or something like that or even today. Okay? Yeah. So whenever you're gonna have a break in your practice and you wanna freeze your account, you can, of course, use, like, the pause feature we have.' (00:02:15-00:02:31)",
    mi_adherent:
      "The salesperson affirms the client's engagement with the classes. 'You're also one of the first students that have been so active, like, in my experience with regards to a seven day free trial. Really, really great job as well. I'm so happy.' (00:00:25-00:00:36). The salesperson also emphasizes autonomy by letting her know about options, such as pausing. 'You can cancel it whenever you'd like, whenever you know. You're like, you know, you wanna actually stop your practice because, okay, I foresee that things are not gonna go well for me, and there's not enough time. You can, of course, reach out to me.' (00:02:59-00:03:17)",
    mi_nonadherent:
      "The salesperson attempts to persuade the customer to continue the membership by highlighting expiring offers without first exploring the customer's ambivalence. 'But in all honesty, we've got a few offers on free trial, and I don't want them to expire. So that's why I actually called to give you a heads up that it's your last day.' (00:03:17-00:03:24)",
    open_questions:
      "The salesperson asked multiple open questions. For example, 'I just wanted to know how you liking them so far?' (00:00:37-00:00:45). Another example, 'Have you found a few classes you like in regards to timings and stuff?'(00:01:03-00:01:07). 'Do you see yourself having, like, one or two sessions a week?' (00:07:33-00:07:40)",
    overall_score:
      'The overall score is a 3, reflecting a moderate level of MI adherence. The salesperson demonstrates some partnership and empathy, but also exhibits some non-adherent behaviors. There is room to improve in cultivating change talk. The positive adherence and non-adherent behaviors balance each other out.',
    partnership:
      "The salesperson generally adopts a collaborative approach, offering assistance and information. 'If you need any help resetting a password or something like that, let me know. I can help you.' (00:05:25-00:05:30). The salesperson asks, 'Can you make something work for me?' (00:02:08-00:02:11) showing collaboration and a desire to meet the customer's needs.",
    simple_reflections:
      "The customer suggests the salesperson can 'make something work for me?', and the salesperson replies with, 'Okay. I see.' (00:02:07-00:02:11)",
    softening_sustain_talk: 'The salesperson does attempt to address sustain talk ('
  },
  overall_score: 3
};

function MitiScore(props) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const [ticketId, setTicketId] = useState('');

  const fetchZendesk = async () => {
    if (ticketId.trim().length < 3) {
      return;
    }

    setLoading(true);

    const url = get_api_url(
      `/v2/crons-tasks/poc/zendesk_miti_score?ticketid=${ticketId.trim()}`,
      false,
      true
    );

    // console.log("endpoint", url);
    try {
      const response = await get_api(url, true);
      const newItems = [...items];
      let sdata = response.data.score;

      if (typeof sdata === 'string') {
        sdata = JSON.parse(sdata);
      }

      sdata.ticketId = ticketId;

      newItems.unshift(sdata);

      setItems(newItems);
    } catch (e) {
      console.log('api call failed', e);
    }

    setLoading(false);
  };

  // useEffect(() => {
  //     setItems([dummy])
  // }, [])

  const gk = useMemo(() => Object.keys(dummy.global_scores), []);
  const bk = useMemo(() => Object.keys(dummy.behavior_counts), []);

  const toolContent = (content) =>
    // console.log("content", content)
    `<div style="width:200px;color: black; background: white;padding: 16px;">${content}</div>`;
  return (
    <div className="">
      <div className="mb-10 ">
        <div className="font-bold text-[24px] capitalize">Miti Score</div>

        {!loading && (
          <div className="flex flex-row w-full gap-4">
            <input
              className="border-indigo-500 border-0 border-b-2 w-1/2"
              type="text"
              autoCorrect="false"
              placeholder="enter zendesk ticket id"
              value={ticketId}
              onChange={(e) => setTicketId(e.currentTarget.value)}
            />

            <span
              className="bg-green-500 hover:bg-green-600 w-32 p-2 rounded-lg text-center self-center text-white cursor-pointer"
              onClick={fetchZendesk}
            >
              Fetch
            </span>
          </div>
        )}

        {loading && <p>Loading...</p>}
        <table>
          <thead>
            <tr>
              <th colSpan="1">Ticket</th>
              <th colSpan="1">Overall</th>
              <th colSpan="4" className="text-center bg-gray-200">
                Global
              </th>
              <th colSpan="7">Behaviour Counts</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Id</td>
              <td>Score</td>
              {gk.map((k) => (
                <td className="bg-gray-200">{k}</td>
              ))}
              {bk.map((k) => (
                <td>{k}</td>
              ))}
            </tr>
            {items &&
              items.length > 0 &&
              items.map((item) => (
                <tr>
                  <td>{item.ticketId}</td>
                  <td
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html={toolContent(item.justification?.overall_score || '')}
                    className="cursor-pointer"
                  >
                    {item.overall_score}
                  </td>
                  {gk.map((k) => (
                    <td
                      data-tooltip-id="my-tooltip"
                      data-tooltip-html={toolContent(item.justification?.[k] || '')}
                      className="cursor-pointer bg-gray-200"
                    >
                      {' '}
                      {item.global_scores[k]}
                    </td>
                  ))}
                  {bk.map((k) => (
                    <td
                      data-tooltip-id="my-tooltip"
                      data-tooltip-html={toolContent(item.justification?.[k] || '')}
                      className="cursor-pointer"
                    >
                      {item.behavior_counts[k]}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MitiScore;
